import type { ContractType } from '@graphql/reactQuery';
import type { ReleaseType } from '@graphql/reactQuery';

export const getReleaseTypeString = (type: ReleaseType) => {
  switch (type) {
    case 'SINGLE':
      return 'Song';
    case 'ALBUM':
      return 'Album';
    default:
      return 'Song';
  }
};

export const isEditReleaseDisabled = ({
  releaseType,
  auctionContractType,
}: {
  releaseType: ReleaseType;
  auctionContractType: ContractType;
}) => {
  return releaseType !== 'SINGLE' || auctionContractType === 'ARTIST';
};
